export default __webpack_public_path__ + "static/media/footer_banner-300x70.1c1bf905.png";